import { Component, OnDestroy } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { UserFacade } from '../store/user/facade/user.facade';
import { CreateAccountPresenter } from './create-account.presenter';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { Ga4Service } from '../services/ga4.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
})
export class CreateAccountComponent implements OnDestroy {
  authError$ = this.userFacade.authError$;
  createAccountForm!: FormGroup;
  isEmailEntered: boolean = false;
  isPasswordEntered: boolean = false;
  submitted: boolean = false;
  error: string;
  isLoading = false;
  sessionResult: any;
  title: string = 'Sign up';
  subTitle: string =
    'Get Started – Fill Out the Form Below.';

  constructor(
    private router: Router,
    private createAccountPresenter: CreateAccountPresenter,
    private userFacade: UserFacade,
    private route: ActivatedRoute,
    private userservice: UserService,
    private ga4: Ga4Service,
    private toastr: ToastrService
  ) {
    this.isLoading = false;
  }

  ngOnInit() {
    this.isLoading = false;
    console.log(this.isLoading)
    this.createAccountForm =
      this.createAccountPresenter.initializeCreateAccountForm();
    this.authError$.subscribe((error) => {
      if (error) {
        this.error = error;
        this.isLoading = false;
      }
    });

    this.route.queryParams.subscribe(params => {
      const sessionId = params['session_id'];
      console.log('sessionId from query params:', sessionId);
      if (sessionId) {
        this.userservice.getSessionDeatils(sessionId).subscribe((result) => {
          console.log(result)
          this.sessionResult = result;
          if (this.sessionResult.accountExists) {
            this.isLoading = false;
            this.router.navigate(['/signin']);
            this.toastr.success('An account with this email already exists. Please sign in.', '', {
              positionClass: 'toast-top-center',
              closeButton: false,
              timeOut: 4500,
            });
          } else {
            if (this.sessionResult.email) {
              this.createAccountForm.get('email')?.setValue(this.sessionResult.email);
              this.toastr.success('Check your email for a temporary password.', '', {
                positionClass: 'toast-top-center',
                closeButton: false,
                timeOut: 4500,
              });
            }
          }

        });
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.createAccountForm.controls;
  }

  clearInput(input: string): void {
    this.createAccountForm.controls['email'].setValue('');
  }

  createAccount() {
    this.submitted = true;
    if (this.createAccountForm.invalid) {
      console.log("this.error")

      return;
    }
    let formValue = this.createAccountForm.value;
    if (formValue.password != formValue.confirmPassword) {
      this.error = 'Passwords are not equal';
      console.log(this.error)
      return;
    }

    this.isLoading = true;
    this.ga4.event('sign_up', { method: 'email' });
    console.log(this.createAccountForm.value)
    this.userFacade.createNewAccount(this.createAccountForm.value);
  }

  hasEmailError(): boolean {
    return this.createAccountForm.controls['email'].invalid;
  }

  navigateToSignin() {
    this.isLoading = false;
    this.router.navigate(['/signin']);
  }

  ngOnDestroy(): void {
    this.isLoading = false;
    this.userFacade.resetErrorMsg();
  }
}
